// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"19001ff8","511":"4e3e78c1","673":"db26238b"}[chunkId] + ".chunk.js";
};